import { z } from 'zod';

const issueSchema = z.object({
  id: z.string(),
  label: z.string().trim().min(1, { message: 'Issue label is required' }),
  text: z.string().trim().optional(),
});

export const subsetFormSchema = z.object({
  name: z.string().trim().min(1, { message: 'Subset name is required' }),
  issues: z.array(issueSchema),
});

export type IssueFormData = z.infer<typeof issueSchema>;
export type SubsetFormData = z.infer<typeof subsetFormSchema>;
